import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from '../components/expandableSection';
import { PanelItem } from './panelItem';
export const PlayerBioExpandableSectionContainer = ({ isSelfPanel, bio }) => {
    if (!bio) {
        return null;
    }
    const expandableSectionType = isSelfPanel ? 'self-bio' : 'player-bio';
    return (_jsx(ExpandableSection, { expandableSectionType: expandableSectionType, colorType: 'player-info', children: _jsx(PanelItem, { children: bio }) }));
};
